import React from 'react'

const Accreditations = () => {
    return (
        <>

            <div className="gallery-area" style={{marginTop:"40px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mx-auto">
                            <div className="site-heading text-center wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <span className="site-title-tagline"><i className="fas fa-solar-panel" />Yogesh Solar Energy</span>
                                <h2 className="site-title">Government-Provided <span> Certificates </span></h2>
                                <div className="heading-divider" />
                            </div>
                        </div>
                    </div>
                    <div className="row g-4 popup-gallery">
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/c1.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/c1.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/c2.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/c2.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/c3.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/c3.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/c4.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/c4.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/c5.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/c5.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/c6.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/c6.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/c7.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/c7.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-md-3">
                            <div className="gallery-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/c8.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/c8.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>


        </>
    )
}

export default Accreditations